var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('v-container',[_c('user-data-form',{attrs:{"user":_vm.user}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }